import {Migration} from '@mydocma/core/src/lib/migration';
import {IDBPDatabase} from 'idb';
import {MmProjectDbCollections} from '../../mm-project-db-schema';

export const V15: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.deleteObjectStore(MmProjectDbCollections.structures);
    database.createObjectStore(MmProjectDbCollections.structures, { keyPath: 'Id' });
  },

};
